export default "__VITE_ASSET__Cjn25a5L__"